module.exports = __webpack_public_path__ + "static/media/left-arrow.94d802a7.svg";